var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('google-map',{ref:"gm",attrs:{"sharer":_vm.sharerId,"show-lengend":_vm.showLegend,"map-style":"elevation","show-sites":true,"legend":_vm.legend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }